import { ElNotification } from 'element-plus';

const showToast = (content, properties = {}) => {
  const position = properties.position || 'bottom-right';
  const iconClass = properties.iconClass || 'bx bx-bell'
  ElNotification({ ...properties, iconClass: null, dangerouslyUseHTMLString: true,
    message: '<div class="notification-content"><i class="' + iconClass + '"></i> ' + content + '</div>',
    position: position });
}

const closeAllToasts = () => {
  ElNotification.closeAll();
}

export {
  showToast,
  closeAllToasts,
}
